import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "tags" })
export class TagsPipe implements PipeTransform {
  constructor() {}
  transform(value) {
    let result = "";
    switch (value) {
      case "add":
        result = "新增";
        break;
      case "modify":
        result = "修改";
        break;
      case "remove":
        result = "删除";
        break;
      default:
        break;
    }
    return result;
  }
}
